import React from 'react';
import waveImage from './wave2.png'; // Adjust the path based on where you placed your image

const MyComponent = () => (
  <div className='hcontainer'>
    <div className="btext">
      <h1 className="btitle">Explore Our Blogs</h1>
      <p className="bp">Dive into our collection of blogs where we share insights, stories, and resources to help you connect with the rich culture and language of Punjab. Whether you're a student or simply interested in learning more, our blogs provide the perfect blend of education and culture.</p>
    </div>
    <section className="pattern">
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>
      <div className="wave wave4"></div>
    </section>

    <style>{`
      .hcontainer {
        width: 100%;
        height: 35%;
        overflow: hidden; 
      }

      .btext {
        padding: 100px 20px;
        padding-bottom:75px;
        text-align: center;
        background-color: #e1cdbc;
        position: relative; 
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
      }

      .btitle {
        margin: 0;
        margin-top: 40px;
        font-size: 3em; 
      }

      .bp {
        width: 55%; 
        margin: 30px auto;
        line-height: 1.6; 
        font-size: 1.1em; 
      }

      .pattern {
        width: 100vw;
        min-height: 80px;
        position: relative;
          background: linear-gradient(-225deg, #f9f9f9, #e8e8e8);
        overflow: hidden;
        margin-top: -2px; 
        z-index: 1; 
      }

      .wave {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 80px;
        background: url(${waveImage});
        background-size: 800px 80px;
        background-repeat: repeat-x;
      }

      .wave.wave1 {
        animation: animate 20s linear infinite; 
        z-index: 1000;
        opacity: 1;
        animation-delay: 0s;
      }

      @keyframes animate {
        0% { background-position-x: 0; }
        100% { background-position-x: 800px; } 
      }

      .wave.wave2 {
        animation: animate2 25s linear infinite; 
        z-index: 999;
        opacity: 0.5;
        animation-delay: -5s;
      }

      @keyframes animate2 {
        0% { background-position-x: 0; }
        100% { background-position-x: -800px; } 
      }

      .wave.wave3 {
        animation: animate 30s linear infinite;
        z-index: 998;
        opacity: 0.2;
        animation-delay: -2s;
      }

      .wave.wave4 {
        animation: animate2 40s linear infinite; 
        z-index: 997;
        opacity: 0.7;
        animation-delay: 0s;
      }
    `}</style>
  </div>
);

export default MyComponent;
